import React from 'react';

import UppyUploader from '@components/common/uppy/main';
import UGTDisclaimer from '@components/common/language_menu/ugtDisclaimer';
import { get as getCsvUploads } from '@api/v4/private/csv_uploads';
import CsvRow from './csv_row';
import { getUgtLocaleSearchString, getLanguageMapEntryFromSearchString } from '../user_generated_translations/bulk_ugt_helpers';
import BulkManagementLanguageMenuDropdown from '../user_generated_translations/BulkManagementLanguageMenuDropdown';


import './styles/main.scss';

class CsvUpload extends React.Component {
  state = {
    csvUploads: null
  }

  componentDidMount() {
    getCsvUploads()
      .then((response) => {
        this.setState({ csvUploads: response });
      })
      .catch();
  }

  triggerUpload = (files) => {
    this.uploadCSV(files[0].url);
  }

  uploadCSV = (url) => {
    fetch(`/${BF.fx.resource().slug}/assets/csv/upload_assets${getUgtLocaleSearchString()}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BF_Token}`
      },
      body: JSON.stringify({
        csv_url: url,
        resource_key: BF.fx.brandfolder().key
      })
    })
      .then((response) => {
        if (!response.ok) {
          Notify.create({
            title: `${t('Something went wrong. Try again soon!')}`,
            type: 'error'
          });
        }
        Notify.create({
          title: `${t('CSV Uploaded')}`,
          body: `${t('It may take a few moments for your changes to be reflected. Reloading...')}`,
          type: 'success'
        });
        window.location.reload();
        return response;
      });
  };

  trigger = () => 'uppy-csv-upload-trigger';

  renderArea() {
    return (
      <div id={this.trigger()} className="uppy-csv-area">
        <span className="bff-plus" />
        <p>{t("Click to upload a CSV")}</p>
      </div>
    );
  }

  render() {
    return (
      <>
        <UGTDisclaimer getSelectedLanguage={getLanguageMapEntryFromSearchString} />
        <div className="csv-metasheets-header">
          <h2>{t('CSV Metasheets')}</h2>
          <BulkManagementLanguageMenuDropdown />
        </div>
        <hr />
        {this.renderArea()}
        <UppyUploader
          {...this.props}
          template="file_ingest"
          handleUpload={this.triggerUpload}
          uniqIdentifier={`csv-uppy-${BF.fx.brandfolder().key}`}
          restrictions={{
            // 35.85mb: a csv with roughly 1m rows
            maxFileSize: 35800000,
            maxNumberOfFiles: 1,
            allowedFileTypes: ['.csv']
          }}
          button
          trigger={`#${this.trigger()}`}
        />
        <div className="headers">
          <h3 className="twenty-five">{t("Upload Date")}</h3>
          <h3 className="thirty">{t("Uploaded by")}</h3>
          <h3 className="ten center">{t("Successful")}</h3>
          <h3 className="ten center">{t("Invalid")}</h3>
          <h3 className="ten center">{t("Failed")}</h3>
          <h3 className="ten center">{t("Total")}</h3>
          <h3 className="ten center">{t("Status")}</h3>
        </div>
        {this.state.csvUploads ? (
          this.state.csvUploads.map((csv_upload) => (
            <div className="csv-row" key={csv_upload.id}>
              <CsvRow csv_upload={csv_upload} />
            </div>
          ))
        ) : (
          <h3>{t("Loading Metasheets...")}</h3>
        )}
      </>
    );
  }
}

export default CsvUpload;
